.typing-indicator {
  display: flex;
  align-items: center;
  background-color: var(--message-robot-background-color);
  height: 100%;
  padding: 0 10px;

  &__dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    margin: 0 4px;
    border-radius: 50%;
    background-color: var(--color-primary);
    animation: typing-indicator__animation 1.5s infinite ease-in-out;

    &:nth-child(1) {
      animation-delay: 0s;
    }

    &:nth-child(2) {
      animation-delay: 0.3s;
    }

    &:nth-child(3) {
      animation-delay: 0.6s;
    }
  }
}

@keyframes typing-indicator__animation {
  0%,
  80%,
  100% {
    opacity: 0.2;
  }
  40% {
    opacity: 1;
  }
}
